import { render, staticRenderFns } from "./TipPerWaiter.vue?vue&type=template&id=5139e526&scoped=true"
import script from "./TipPerWaiter.vue?vue&type=script&lang=js"
export * from "./TipPerWaiter.vue?vue&type=script&lang=js"
import style0 from "./TipPerWaiter.vue?vue&type=style&index=0&id=5139e526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5139e526",
  null
  
)

export default component.exports